import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import EditVersion from '../components/creative-info/edit-version-drawer.vue';

export default {
  components: {
    EditVersion: EditVersion
  },

  data: function data() {
    return {
      newName: '',
      dialogVisible: false
    };
  },


  computed: _extends({}, mapState({
    id: function id(state) {
      return state.creative.template.id;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    isReadonly: function isReadonly(state) {
      return state.creative.template.isReadonly;
    },
    isDMaker: function isDMaker(state) {
      return state.pt.isDMaker;
    }
  }), {
    name: function name() {
      return this.newName || this.templateConfig.name;
    },
    lvl2Text: function lvl2Text() {
      var textTemp = this.$t('playTurbo.creative.nav.version');
      return textTemp;
    },
    lvl3Text: function lvl3Text() {
      var textTemp = this.$t('playTurbo.creative.nav.versionEdit');
      return textTemp;
    },
    templateRoute: function templateRoute() {
      var routeTemp = {
        name: 'creative-service.playable.list',
        params: {
          templateId: this.$route.params.templateId
        }
      };
      return routeTemp;
    },
    versionRoute: function versionRoute() {
      var routeTemp = {
        name: 'template.version.list',
        params: {
          templateId: this.$route.params.templateId
        }
      };
      return routeTemp;
    },
    tab: function tab() {
      return 'normal';
    }
  }),

  methods: {
    handleUpdateSuccess: function handleUpdateSuccess(_ref) {
      var id = _ref.id,
          name = _ref.name,
          apps = _ref.apps;

      this.newName = name;
    },
    handleEditVersion: function handleEditVersion() {
      this.dialogVisible = true;
    }
  }
};